export default __webpack_public_path__ + "static/banner-68399da5b683e4721acbf85864a8ee95.jpg";